import React from "react";
import BasicPage from "../../../common/basicPage/BasicPage";
import {CelebrateIcon} from "./CelebrateIcon";
import onboarding from "../../../../services/onboarding/onboarding";

interface IYouAreAllSetProps {
  
}

export default function YouAreAllSet({}: IYouAreAllSetProps) {
  const headerTextContent: string = "You're all set!"

  return (
    <BasicPage
      useMosaicBackground={true}
      headerIconComponent={<CelebrateIcon/>}
      portraitModeHeaderText={headerTextContent}
      content={
        <>
          <h1>{headerTextContent}</h1>
          <p>You&apos;re ready to start learning with Playground Sessions.</p>
          <p>Next up is <strong>Bootcamp</strong>, our step-by-step learning path designed to help you build a strong foundation, whether you&apos;re brand new or brushing up on your skills.
          </p>
        </>
      }
      actionButton={{
        text: "Start playing",
        onClick: () => {
          onboarding.completeOnboarding();
        },
        buttonType: "secondary",
      }}
    />
  );
}
